$ var isMini = input.variant === "_mini";
$ var buttonPosition = input.buttonPosition || 'right';

<ebay-dialog-base
    ...input
    open=input.open
    class-prefix="lightbox-dialog"
    on-open("emit", "open")
    on-close("emit", "close")
    button-position=buttonPosition
    class=[input.class, "lightbox-dialog--mask-fade"]
    window-class=[
        "lightbox-dialog__window--fade",
        isMini && "lightbox-dialog__window--mini"
    ]>
</ebay-dialog-base>
